const NoData = ({ height, message }) => {
    return (
        <div style={{ minHeight: height ?? "30vh", display: "flex", alignItems: "center", justifyContent: "center" }}>
            <h2>{message ?? "No data found"}</h2>
        </div>
    );
};

export default NoData;